import * as ReactDOMClient from "react-dom/client";
import App from "./App";
import { MaterialUIControllerProvider } from "./context";
import { BrowserRouter } from "react-router-dom";
import LoadingContext from "./context/LodingContext";
import { ApolloProvider, ApolloClient, InMemoryCache } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import BASEURL from "./pages/Utils/Baseurl";
import createProgressUploadLink from "./food/salesorder/UploadPercentage";
import LoginContextProvider from "./meefood/context/loginContext/LoginContextProvider";

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container);
const uploadLink = createProgressUploadLink
  ? createProgressUploadLink((progress) => {
    })
  : createUploadLink({ uri: BASEURL });

const client = new ApolloClient({
  link: uploadLink,
  cache: new InMemoryCache(),
});

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <LoginContextProvider>
        <LoadingContext>
          <ApolloProvider client={client}>
            <App />
          </ApolloProvider>
        </LoadingContext>
      </LoginContextProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
